import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import FollowUpsNav from "./FollowUpsNav";

import { MESSAGES } from "../../../utils/data/models";
import * as dataActions from "../../../utils/data/dataActions";

class FollowUps extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentWillMount() {
    const userId = this.props.auth.user.userId;
    this.props.dataActions.getDataCount(MESSAGES, [
      `messagesUnread.userId==${userId}`,
    ]);
  }

  componentDidUpdate() {
    const userId = this.props.auth.user.userId;
    this.props.dataActions.getDataCount(MESSAGES, [
      `messagesUnread.userId==${userId}`,
    ]);
  }

  render() {
    const { children } = this.props;
    return (
      <div>
        <div className="page-header">
          <div className="main clearfix">
            <div className="main-name">
              <h2>
                <FormattedMessage id="followUps.title" />
              </h2>
            </div>
          </div>
          <FollowUpsNav
            followUpsCount={this.props.followUpsCount}
            messagesCount={this.props.messagesCount}
          />
        </div>
        {!!children ? <div className="sub-container">{children}</div> : ""}
      </div>
    );
  }
}

FollowUps.propTypes = {
  auth: PropTypes.object,
  children: PropTypes.node,
  dataActions: PropTypes.object,
  followUpsCount: PropTypes.number,
  messagesCount: PropTypes.number,
};

function mapStateToProps(state) {
  const followUps = state.data.followUpsCount || {};
  const messages = state.data.messagesCount || {};
  return {
    auth: state.auth,
    followUpsCount: followUps.count || 0,
    messagesCount: messages.count || 0,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FollowUps);



// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/FollowUpsPage.js